import { render, staticRenderFns } from "./ExternalLinks.vue?vue&type=template&id=19999fae&"
import script from "./ExternalLinks.vue?vue&type=script&lang=js&"
export * from "./ExternalLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19999fae')) {
      api.createRecord('19999fae', component.options)
    } else {
      api.reload('19999fae', component.options)
    }
    module.hot.accept("./ExternalLinks.vue?vue&type=template&id=19999fae&", function () {
      api.rerender('19999fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExternalLinks.vue"
export default component.exports